import { defineMessages } from 'react-intl';

export default defineMessages({
  breadcrumbEdit: {
    id: 'company.breadcrumb.edit',
    defaultMessage: 'Edit Company',
  },
  breadcrumbRegister: {
    id: 'company.breadcrumb.register',
    defaultMessage: 'Register New Company',
  },
  breadcrumbCompanyList: {
    id: 'company.breadcrumb.list',
    defaultMessage: 'Company List',
  },
  btnRegister: {
    id: 'company.form.btn.register',
    defaultMessage: 'Register Company',
  },
  btnEdit: {
    id: 'company.form.btn.edit',
    defaultMessage: 'Simpan',
  },
  formLabelPassword: {
    id: 'company.form.label.password',
    defaultMessage: 'Company Password',
  },
  formRequiredPassword: {
    id: 'company.form.warning.required.password',
    defaultMessage: 'Password wajib di isi',
  },
  formPlaceholderPassword: {
    id: 'company.form.placeholder.password',
    defaultMessage: 'Masukkan password',
  },
  formInvalidPassword: {
    id: 'company.form.warning.invalid.password',
    defaultMessage:
      'Kata sandi setidaknya terdiri dari satu angka, satu huruf kecil, satu huruf besar dan 8-16 karakter',
  },
  formLeftTitle: {
    id: 'company.form.left.title',
    defaultMessage: 'Company Details',
  },
  formLabelCompanyName: {
    id: 'company.form.label.companyName',
    defaultMessage: 'Nama Company',
  },
  formRequiredCompanyName: {
    id: 'company.form.warning.required.companyName',
    defaultMessage: 'Nama Company wajib di isi',
  },
  formPlaceholderCompanyName: {
    id: 'company.form.placeholder.companyName',
    defaultMessage: 'Masukkan nama company',
  },
  formLabelAddress: {
    id: 'company.form.label.address',
    defaultMessage: 'Alamat Company',
  },
  formRequiredAddress: {
    id: 'company.form.warning.required.companyAddr',
    defaultMessage: 'Alamat Company wajib di isi',
  },
  formPlaceholderAddress: {
    id: 'company.form.placeholder.companyAddr',
    defaultMessage: 'Masukkan alamat company',
  },
  formLabelCity: {
    id: 'company.form.label.city',
    defaultMessage: 'Kota',
  },
  formRequiredCity: {
    id: 'company.form.warning.required.city',
    defaultMessage: 'Kota wajib di isi',
  },
  formPlaceholderCity: {
    id: 'company.form.placeholder.city',
    defaultMessage: 'Masukkan kota',
  },
  formLabelDistrict: {
    id: 'company.form.label.district',
    defaultMessage: 'Kecamatan',
  },
  formRequiredDistrict: {
    id: 'company.form.warning.required.district',
    defaultMessage: 'Kecamatan wajib di isi',
  },
  formPlaceholderDistrict: {
    id: 'company.form.placeholder.district',
    defaultMessage: 'Masukkan kecamatan',
  },
  formLabelPostalCode: {
    id: 'company.form.label.postalCode',
    defaultMessage: 'Kode Pos',
  },
  formRequiredPostalCode: {
    id: 'company.form.warning.required.postalCode',
    defaultMessage: 'Kodepos wajib di isi',
  },
  formPlaceholderPostalCode: {
    id: 'company.form.placeholder.postalCode',
    defaultMessage: 'Masukkan kode pos',
  },
  formLabelOwner: {
    id: 'company.form.label.owner',
    defaultMessage: 'Owner',
  },
  formLabelCompanyID: {
    id: 'company.form.label.companyID',
    defaultMessage: 'Company ID',
  },
  formPlaceholderCompanyID: {
    id: 'company.form.placeholder.companyID',
    defaultMessage: 'Your Company ID',
  },
  formLabelNpwpNumber: {
    id: 'company.form.label.npwpNumber',
    defaultMessage: 'NPWP Number',
  },
  formRequiredNpwpNumber: {
    id: 'company.form.warning.required.npwpNumber',
    defaultMessage: 'NPWP Number must be filled',
  },
  formPlaceholderNpwpNumber: {
    id: 'company.form.placeholder.npwpNumber',
    defaultMessage: 'Your NPWP Number',
  },
  formLabelLegalEntity: {
    id: 'company.form.label.legalEntity',
    defaultMessage: 'Legal Entity',
  },
  formRequiredLegalEntity: {
    id: 'company.form.warning.required.legalEntity',
    defaultMessage: 'Legal Entity must be filled',
  },
  formPlaceholderLegalEntity: {
    id: 'company.form.placeholder.legalEntity',
    defaultMessage: 'Your Legal Entity',
  },
  formRequiredOwner: {
    id: 'company.form.warning.required.owner',
    defaultMessage: 'Pemilik Company wajib di isi',
  },
  formPlaceholderOwner: {
    id: 'company.form.placeholder.owner',
    defaultMessage: 'Masukkan nama company owner',
  },
  formPlaceholderCompanyEmail: {
    id: 'company.form.placeholder.companyEmail',
    defaultMessage: 'Masukkan email company',
  },
  formLabelRole: {
    id: 'company.form.label.role',
    defaultMessage: 'Role',
  },
  formRequiredRole: {
    id: 'company.form.warning.required.role',
    defaultMessage: 'Company Role wajib di isi',
  },
  formPlaceholderRole: {
    id: 'company.form.placeholder.role',
    defaultMessage: 'Pilih role',
  },
  formRightTitle: {
    id: 'company.form.right.title',
    defaultMessage: 'Company Details',
  },
  formLabelEmail: {
    id: 'company.form.label.email',
    defaultMessage: 'Company Email Address',
  },
  formRequiredEmail: {
    id: 'company.form.warning.required.email',
    defaultMessage: 'Email wajib di isi',
  },
  formInvalidEmail: {
    id: 'company.form.warning.invalid.email',
    defaultMessage: 'Format email salah',
  },
  formPlaceholderEmail: {
    id: 'company.form.placeholder.email',
    defaultMessage: 'Masukkan email',
  },
  formLabelUsername: {
    id: 'company.form.label.username',
    defaultMessage: 'Company Username',
  },
  formLabelCompanyPICName: {
    id: 'company.form.label.companyPICName',
    defaultMessage: 'Company PIC Name',
  },
  formPlaceholderCompanyPICName: {
    id: 'company.form.placeholder.companyPICName',
    defaultMessage: 'Your company PIC name',
  },
  formRequiredCompanyPICName: {
    id: 'company.form.warning.required.companyPICName',
    defaultMessage: 'Nama Company PIC wajib di isi',
  },
  formLabelCompanyPICEmail: {
    id: 'company.form.label.companyPICEmail',
    defaultMessage: 'Email',
  },
  formPlaceholderCompanyPICEmail: {
    id: 'company.form.placeholder.companyPICEmail',
    defaultMessage: 'Your company PIC email',
  },
  formLabelCompanyPICPhone: {
    id: 'company.form.label.companyPICPhone',
    defaultMessage: 'Phone Number',
  },
  formPlaceholderCompanyPICPhone: {
    id: 'company.form.placeholder.companyPICPhone',
    defaultMessage: 'Your company PIC phone number',
  },
  formLabelCompanyPICID: {
    id: 'company.form.label.companyPICID',
    defaultMessage: 'National ID',
  },
  formPlaceholderCompanyPICID: {
    id: 'company.form.placeholder.companyPICID',
    defaultMessage: 'Your company PIC National ID number',
  },
  formLabelCompanyPICPhoto: {
    id: 'company.form.label.companyPICPhoto',
    defaultMessage: 'Photo',
  },
  formPlaceholderCompanyPICPhoto: {
    id: 'company.form.placeholder.companyPICID',
    defaultMessage: 'Your company PIC photo',
  },
  formRequiredCompanyPICPhoto: {
    id: 'company.form.warning.required.companyPICPhoto',
    defaultMessage: 'Photo is empty',
  },
  registerSuccessMessage: {
    id: 'company.form.alert.registerSuccess',
    defaultMessage: 'Registrasi Company Sukses',
  },
  editSuccessMessage: {
    id: 'company.form.alert.editSuccessMessage',
    defaultMessage: 'Edit Company Sukses',
  },
  errorMessage: {
    id: 'company.form.alert.errorMessage',
    defaultMessage: 'There is something error',
  },
  formLabelAllowedModules: {
    id: 'company.form.label.allowedModules',
    defaultMessage: 'Allowed Modules',
  },
  formLabelAvailableEmployeeRoles: {
    id: 'company.form.label.availableEmployeeRoles',
    defaultMessage: 'Available Employee Roles',
  },
  formLabelModulesPermission: {
    id: 'company.form.label.modulesPermission',
    defaultMessage: 'ModulesPermission',
  },
  formRequiredPicPhone: {
    id: 'company.form.warning.required.picPhone',
    defaultMessage: 'Nomor telepon wajib diisi',
  },
  formRequiredPicNationalID: {
    id: 'company.form.warning.required.picNationalID',
    defaultMessage: 'National ID wajib diisi',
  },
  formRequiredEmployeeRoles: {
    id: 'company.form.warning.required.employeeRoles',
    defaultMessage: 'Employee role wajib dipilih',
  },
  createNewCompanySuccessDescription: {
    id: 'company.form.create.success.description',
    defaultMessage: 'Finished registering your company',
  },
  createNewCompanyErrorDescription: {
    id: 'company.form.create.error.description',
    defaultMessage: 'Create new company failed',
  },
  rollbackConfirmationTitle: {
    id: 'company.modal.rollback.confirm.title',
    defaultMessage: 'Confirmation',
  },
  rollbackConfirmationDescription: {
    id: 'company.modal.rollback.confirm.description',
    defaultMessage: 'Are you sure want to cancel registering progress?',
  },
  rollbackConfirmationBtnOk: {
    id: 'company.modal.rollback.confirm.btn.ok',
    defaultMessage: 'Yes',
  },
  rollbackConfirmationBtnCancel: {
    id: 'company.modal.rollback.confirm.btn.cancel',
    defaultMessage: 'No',
  },
  rollbackSuccessTitle: {
    id: 'company.modal.rollback.success.title',
    defaultMessage: 'Success',
  },
  rollbackSuccessDescription: {
    id: 'company.modal.rollback.success.description',
    defaultMessage: 'Rollback success',
  },
  rollbackSuccessBtnOk: {
    id: 'company.modal.rollback.success.btn.ok',
    defaultMessage: 'Ok',
  },
  rollbackErrorTitle: {
    id: 'company.modal.rollback.error.title',
    defaultMessage: 'Error',
  },
  rollbackErrorDescription: {
    id: 'company.modal.rollback.error.description',
    defaultMessage: 'Rollback error, please try again',
  },
  rollbackErrorBtnRetry: {
    id: 'company.modal.rollback.error.btn.retry',
    defaultMessage: 'Retry',
  },
  updateCompanySuccessDescription: {
    id: 'company.form.update.success.description',
    defaultMessage: 'Update successful',
  },
  updateCompanyErrorDescription: {
    id: 'company.form.update.error.description',
    defaultMessage: 'Update failed',
  },
  createCompanyModalTitle: {
    id: 'company.modal.create.company.title',
    defaultMessage: 'Registering your company',
  },
  createUserModalTitle: {
    id: 'company.modal.create.user.title',
    defaultMessage: 'Creating user account',
  },
  createEmployeeModalTitle: {
    id: 'company.modal.create.employee.title',
    defaultMessage: 'Registering your first employee',
  },
  updateCompanyModalTitle: {
    id: 'company.modal.update.company.title',
    defaultMessage: 'Updating Company',
  },
  updateUserModalTitle: {
    id: 'company.modal.update.user.title',
    defaultMessage: 'Updating user',
  },
  updateEmployeeModalTitle: {
    id: 'company.modal.update.employee.title',
    defaultMessage: 'Updating company PIC',
  },
  companyFormInvalidPhone: {
    id: 'company.form.validation.phone',
    defaultMessage: 'Start with +62|62|08, number only, min length 9 max 13',
  },
  companyFormInvalidNationalID: {
    id: 'company.form.validation.nationalID',
    defaultMessage: 'National Id must be number only',
  },
  companyFormWarnSelectRole: {
    id: 'company.form.warning.selectRole',
    defaultMessage: 'Select company roles first',
  },
  companyFormWarnModulesCount: {
    id: 'company.form.warning.modulesCount',
    defaultMessage: 'Only 1 module allowed',
  },
  companyFormCreateSubmittingTitle: {
    id: 'company.form.create.submitting.title',
    defaultMessage: 'Registering...',
  },
  companyFormUpdateSubmittingTitle: {
    id: 'company.form.update.submitting.title',
    defaultMessage: 'Updating...',
  },
  companyFormCreateRetryTitle: {
    id: 'company.form.create.retry.title',
    defaultMessage: 'Retry Registering Company',
  },
  companyFormUpdateRetryTitle: {
    id: 'company.form.update.retry.title',
    defaultMessage: 'Retry Updating Company',
  },
  companyFormCreateRemarksErrorTitle: {
    id: 'company.form.create.remarks.error.title',
    defaultMessage: 'Registering Failed',
  },
  companyFormUpdateRemarksErrorTitle: {
    id: 'company.form.update.remarks.error.title',
    defaultMessage: 'Updating Failed',
  },
  companyFormCreateRemarksErrorDescription: {
    id: 'company.form.create.remarks.error.description',
    defaultMessage: 'There is an error when registering your company',
  },
  companyFormUpdateRemarksErrorDescription: {
    id: 'company.form.update.remarks.error.description',
    defaultMessage: 'There is an error when updating your company',
  },
  companyFormCreateRemarksSuccessTitle: {
    id: 'company.form.create.remarks.success.title',
    defaultMessage: 'Registering Success',
  },
  companyFormUpdateRemarksSuccessTitle: {
    id: 'company.form.update.remarks.success.title',
    defaultMessage: 'Updating Success',
  },
  companyFormCreateRemarksSuccessDescription: {
    id: 'company.form.create.remarks.success.description',
    defaultMessage: 'Success registering your company',
  },
  companyFormUpdateRemarksSuccessDescription: {
    id: 'company.form.update.remarks.success.description',
    defaultMessage: 'Success updating your company',
  },
  companyFormCreateRemarksSuccessSubDescription: {
    id: 'company.form.create.remarks.success.subDescription',
    defaultMessage:
      'You can register another company or go back to company list',
  },
  companyFormCreateRemarksCreateAnother: {
    id: 'company.form.create.remarks.createAnother',
    defaultMessage: 'Register Another Company',
  },
  companyStepOneTitle: {
    id: 'headerSteps.company.stepOne.title',
    defaultMessage: 'Pendaftaran Perusahaan',
  },
  companyStepOneDescription: {
    id: 'headerSteps.company.stepOne.description',
    defaultMessage: 'Proses pendaftaran data untuk perusahaan baru',
  },
  companyStepTwoTitle: {
    id: 'headerSteps.company.stepTwo.title',
    defaultMessage: 'Proses Pengaturan Karyawan',
  },
  companyStepTwoDescription: {
    id: 'headerSteps.company.stepTwo.description',
    defaultMessage: 'Proses pemberian peran dan izin untuk karyawan',
  },
  companyStepThreeTitle: {
    id: 'headerSteps.company.stepThree.title',
    defaultMessage: 'Proses Upload Data',
  },
  companyStepThreeDescription: {
    id: 'headerSteps.company.stepThree.description',
    defaultMessage: 'Proses penguploadan data untuk registrasi perusahaan',
  },
});
